import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import './App.css';
import Login from './components/Login';

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/user/login" component={Login} />
        <Redirect from="/" to="/user/login" />
      </Switch>
    </Router>
  );
}

export default App;
